import type { FlowItem } from "../Types/BookShipmentFlowItemType";
import type { ReactNode } from "react";
import BookShipmentNavigationSection from "./BookShipmentNavigationSection";

interface BookShipmentNavigationProps {
  currentFlowIdentifier: string;
  completedFlowItems: Array<string>;
  unlockedFlowItems: Array<string>;
  additionalContentProvider?:
    | ((flowIdentifier: string) => ReactNode)
    | undefined;

  finishBookingFlow: Array<FlowItem>;
  alwaysShowRequestQuoteFlow: boolean;

  onNavigate: (
    currentFlowItem: string,
    proposedFlowItem: string,
  ) => Promise<void>;
}

interface SectionProps {
  title: string;
  flow: Array<FlowItem>;
  completedFlowItems: Array<string>;
  unlockedFlowItems: Array<string>;
  currentFlowIdentifier: string;
  additionalContentProvider?:
    | ((flowIdentifier: string) => ReactNode)
    | undefined;

  onNavigate: (
    currentFlowItem: string,
    proposedFlowItem: string,
  ) => Promise<void>;
}

function Section_(props: SectionProps) {
  return (
    <>
      <BookShipmentNavigationSection
        currentFlowIdentifier={props.currentFlowIdentifier}
        flow={props.flow}
        completedFlowItems={props.completedFlowItems}
        unlockedFlowItems={props.unlockedFlowItems}
        additionalContentProvider={props.additionalContentProvider}
        onNavigate={props.onNavigate}
      ></BookShipmentNavigationSection>
    </>
  );
}

function BookShipmentNavigation(props: BookShipmentNavigationProps) {
  const finishBookingFlow = props.finishBookingFlow;

  return (
    <>
      <div
        className="flex w-[352px] flex-col items-start"
        id="BookShipmentNavigation"
      >
        <Section_
          title="Finalize Shipment"
          flow={finishBookingFlow}
          completedFlowItems={props.completedFlowItems}
          currentFlowIdentifier={props.currentFlowIdentifier}
          unlockedFlowItems={props.unlockedFlowItems}
          additionalContentProvider={props.additionalContentProvider}
          onNavigate={props.onNavigate}
        ></Section_>
      </div>
    </>
  );
}
export default BookShipmentNavigation;
